import { useDesignSystem } from 'contexts/design-system'
import PhoneInputEui from './phoneInput.eui'
import PhoneInputMui from './phoneInput.mui'
import { PhoneInputProps } from './types'

export type { PhoneInputProps } from './types'

/**
 * Shared phone-number input. Renders the EUI or MUI presentation based on the
 * host form's design system (`DesignSystemProvider`, default `'eui'`); label
 * and error presentation come from the shared `FormRow`, so both branches
 * validate identically. Public props and formatting behavior are unchanged.
 */
export default function PhoneInput( props: PhoneInputProps ) {
	return useDesignSystem() === 'mui'
		? <PhoneInputMui {...props} />
		: <PhoneInputEui {...props} />
}
